/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { ApiPatchConfig, UserActivationGuardType } from './user-activation-guard.interface';

export const ApiPatchConfigs: ApiPatchConfig[] = [
    // Navigator.share(): navigator.share is not writable but Navigator.prototype.share is writable.
    {
        object: Navigator.prototype,
        methodName: 'share',
        type: UserActivationGuardType.Share,
        returnsPromise: true
    },
    // window.open()
    {
        object: window,
        methodName: 'open',
        type: UserActivationGuardType.Link
    },
    // Fullscreen API (standard + WebKit)
    {
        object: Element.prototype,
        methodName: 'requestFullscreen',
        type: UserActivationGuardType.PlayMedia,
        returnsPromise: true
    },
    {
        object: Element.prototype,
        methodName: 'webkitRequestFullscreen',
        type: UserActivationGuardType.PlayMedia,
        returnsPromise: true
    },
    // HTMLMediaElement.play() (audio/video)
    {
        object: HTMLMediaElement.prototype,
        methodName: 'play',
        type: UserActivationGuardType.PlayMedia,
        returnsPromise: true
    }
    /*
     * Consideration for Input/TextArea Elements:
     * While ideally we would enforce user activation guards for typeable elements
     * (HTMLInputElement/HTMLTextAreaElement), there are critical implementation constraints,
     * the `focus()` and `select()` methods are writable but exist in the prototype chain (HTMLElement)
     * creating ambiguous execution contexts during guard checks.
     */
];
